const Form002ASC = {
    stepName: {
        ImportantNotes: "重要提示",
        PersonalInfo: "校长资料",
        ServiceRecord: "服务纪录",
        GainedRewards: "曾获公益少年团功绩荣誉奖",
        Confirmation: "确认",
    },
    label: {
        positionOption: {
            teacher: "教師",
            manager: "主任",
            vicePrincipal: "副校長",
            socialWorker: "社工",
            others: "其他",
        },
        positions: {
            chairman: "主席",
            viceChairman: "副主席",
            secretary: "秘书",
            cashier: "司库",
            committee: "委员",
        },
        rewardOption: {
            appreciationFiveYear: "忠诚服务奖（已服务不少于五年）",
            appreciationSevenYear: "良好服务奖（已服务不少于七年）",
            appreciationTenYear: "优异服务奖（已服务不少于十年）",
            appreciationThirteenYear: "铜章（已服务不少于十三年）",
            appreciationSixteenYear: "银章（已服务不少于十六年）",
            appreciationYear: "金章（由本团会长审核及颁赠）",
            noAppreciation: "本人未曾领取任何奖项",
        },
        titleOption: {
            Mr: "先生",
            Ms: "小姐",
            Mrs: "女士",
            Dr: "博士",
        },
        titleOptionE: {
            Mr: "Mr",
            Ms: "Ms",
            Mrs: "Mrs",
            Dr: "Dr.",
        },
        nomineeTitle: "校长称谓",
        nomineeName: "校长姓名",
        position: "职衔",
        specify: "请注明职衔",
        schoolName: "学校",
        schoolAddress: "学校地址",
        schoolTel: "学校电话",
        schoolFax: "传真号码",
        district: "所属分区",
        year: "截至",
        year1: "年度为止（以学年计算），本人担任本团会员学校导师及校长合共_______年，当中不包括中断年份。﹝例：如于2020年9月开始担任，即填1年﹞",
        title2: "最近三年担任本团分区执行委员会职务（在适当位置加「√」）",
        title3: "最近三年统筹区本活动记录：",
        annual: "年度",
        activityName: "活动名称",
        jobCategory: "工作性质（请填写代表数字）：（1）总负责人；（2）协助",
        post: "职务",
        total: "合共",
        nomineeTitleE: "称谓",
        nomineeNameE: "校长英文姓名",
        rewardYear: "获奖年份",
        statement: "声明",
    },
    errorMsg: {
        one: "該年度已填写",
        min3: "请填写最近三年统筹区本活动记录",
    },
};
export default Form002ASC;
